<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'sloped-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const heightLeft = computed({
	get: () => dimensions.value.height_left,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_left",
			value: value,
		});
	},
});

const heightRight = computed({
	get: () => dimensions.value.height_right,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_right",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="sloped-rectangle-width"
			:id="`${prefix}measurements-sloped-rectangle-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width', 'sloped-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}sloped-rectangle-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'sloped-rectangle')"
			v-model="width"
		/>

		<dimension-input
			inputRef="sloped-rectangle-height_left"
			:id="`${prefix}measurements-sloped-rectangle-height_left`"
			:name="`${prefix}measurements[dimensions][height_left]`"
			unit="cm"
			:label="dimensionLabel('height_left', 'sloped-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height_left')"
			:invalid="!isDimensionValid(`${prefix}sloped-rectangle-height_left`)"
			:onBlur="
				() => addSizeToDataLayer('height_left', +heightLeft, 'sloped-rectangle')
			"
			v-model="heightLeft"
		/>

		<dimension-input
			inputRef="sloped-rectangle-height_right"
			:id="`${prefix}measurements-sloped-rectangle-height_right`"
			:name="`${prefix}measurements[dimensions][height_right]`"
			unit="cm"
			:label="dimensionLabel('height_right', 'sloped-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height_right')"
			:invalid="!isDimensionValid(`${prefix}sloped-rectangle-height_right`)"
			:onBlur="
				() => addSizeToDataLayer('height_right', +heightRight, 'sloped-rectangle')
			"
			v-model="heightRight"
		/>
	</shape-input-fields-wrapper>
</template>
